import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch } from "react-redux";
import { shallowEqual, useSelector } from "react-redux";
import { useIntl } from 'react-intl';
import Select, { components } from 'react-select'
import { useFormikContext } from 'formik';
import { PropTypes } from "prop-types";
import * as actions from "../../../../../app/actions/generalActions";
import { useFilterObjectsUIContext } from '../pages/FilterObjectsUIContext';
import { FieldFeedbackLabel } from '../../../../_partials/controls';



export const MultiSelectObjectsField = ({
  api,
  reducerName,
  reduxState,
  sname,
  label,
  keyFieldName,
  valueFieldNames,
  useInFilter = false,
  functionName,
  ...props
}) => {

  const { setFieldValue, handleSubmit, errors, touched } = useFormikContext();
  const { field } = props;

  const objectsUIContext = useFilterObjectsUIContext();
  const objectsUIProps = useMemo(() => {
    return {
      queryParams: objectsUIContext.queryParams,
      setQueryParams: objectsUIContext.setQueryParams,
    };
  }, [objectsUIContext]);

  const { currentState } = useSelector(
    (state) => ({ currentState: state[reduxState] }),
    shallowEqual
  );
  const { entities, name } = currentState;
  const [options, setOptions] = useState(null)
  const [selectedOptions, setSelectedOptions] = useState(field.value)

  const handleChange = selectedOptions => {

    if (selectedOptions.find(x => x.value === "*")) {
      var items = []
      if (entities) {
        entities.forEach(element => {
          items.push({ value: element[keyFieldName], label: element[valueFieldNames] })
        });
      }
      setSelectedOptions([...items]);
      setFieldValue(field.name, [...items])
    }
    else {
      setSelectedOptions(selectedOptions);
      setFieldValue(field.name, selectedOptions)
    }
    if (useInFilter)
      handleSubmit()
    // setSelectedOptions(selectedOptions);
    // var ids = []
    // if (selectedOptions) {
    //   selectedOptions.forEach(element => {
    //     ids.push(element.value)
    //   });
    // }
    // setFieldValue(field.name, ids)
  };

  useEffect(() => {
    var items = []
    if (entities) {
      entities.forEach(element => {
        items.push({ value: element[keyFieldName], label: element[valueFieldNames] })
      });
    }
    if (items.length > 0)
      setOptions([{ label: "همه", value: "*" }, ...items])
    else
      setOptions([...items])
  }, [entities]);


  useEffect(() => {
    // if (field.value === "*" && options !== null && options !== [] && options.length > 0) {
    //   setSelectedOptions([...options])
    // }
    // else
    if (field.value === 0 || field.value === [] || field.value === null) {
      setSelectedOptions(null)
    }
  }, [field.value]);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(actions.fetchSelectObjects(api, name, objectsUIProps.queryParams, functionName));
  }, [objectsUIProps.queryParams, dispatch]);

  const intl = useIntl();
  return (
    <>
      {label && <label> {label}</label>}
      <Select
        value={selectedOptions}
        // className={getFieldCSSClasses(touched[field.name], errors[field.name])}
        name={field.name}
        options={options}
        isMulti={true}
        isSearchable={true}
        noOptionsMessage={() => "تمام رکوردها انتخاب شده است"}
        onChange={handleChange}
        {...props}
      >


      </Select>
      <FieldFeedbackLabel
        // error={errors[field.name]}
        error={errors[field.name] && intl.formatMessage({ id: "YUP.REQUIRED" })}
        touched={touched[field.name]}
        label={label}
        type={field.type}
      // customFeedbackLabel={customFeedbackLabel}
      />
    </>
  )
}


MultiSelectObjectsField.defaultProps = {
  keyFieldName: "id",
  valueFieldNames: "title",
};
